import { Component, type ErrorInfo, type ReactNode } from "react";

type Props = { children: ReactNode };

type State = { error: Error | null };

export class RootErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("[dispensary-web]", error, info.componentStack);
  }

  render(): ReactNode {
    if (this.state.error) {
      const { message, stack } = this.state.error;
      return (
        <div className="min-h-screen bg-white px-6 py-10 text-left font-sans text-gray-700" role="alert">
          <h1 className="text-xl font-semibold text-red">Dispensary web failed to render</h1>
          <p className="mt-4 max-w-2xl text-sm text-gray-500">
            Check the browser console. Common cause: invalid{" "}
            <code className="rounded border border-gray-200 bg-white px-1 font-mono text-sm text-ink">
              VITE_CLERK_PUBLISHABLE_KEY
            </code>
            .
          </p>
          <pre className="mt-6 max-w-3xl overflow-x-auto rounded-lg border border-gray-200 bg-white p-4 text-sm text-red">
            {message}
          </pre>
          {import.meta.env.DEV && stack ? (
            <pre className="mt-4 max-w-3xl overflow-x-auto text-xs text-gray-500">{stack}</pre>
          ) : null}
        </div>
      );
    }
    return this.props.children;
  }
}
